module.exports = __webpack_public_path__ + "img/yangruiyun.c729aa28.jpg";